<template>
  <b-modal ref="modal" @hidden="flush" centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <h5 class="font-weight-bolder m-0">
        <span v-if="id">Update User</span>
        <span v-else>New User</span>
      </h5>

      <b-button
        size="sm"
        variant="none"
        class="btn-icon btn-circle btn-hover-dark"
        title="Close"
        @click="close"
        v-b-tooltip.hover
      >
        <i class="material-icons icon-xl">close</i>
      </b-button>
    </template>

    <template #default>
      <validation-observer ref="observer">
        <div
          class="alert text-center font-weight-bold"
          :class="variants"
          v-html="error || '&nbsp;'"
          v-if="error && error.length"
        />
        <div class="row">
          <div class="col-12">
            <validation-provider
              name="email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <b-form-group label="Email *" label-for="email">
                <b-form-input :disabled="disabled" v-model="object.email" />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="first_name"
              rules="required|max:48"
              v-slot="{ errors }"
            >
              <b-form-group label="First Name *" label-for="first_name">
                <b-form-input
                  :disabled="disabled"
                  v-model="object.first_name"
                />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="last_name"
              rules="required|max:48"
              v-slot="{ errors }"
            >
              <b-form-group label="Last Name *" label-for="last_name">
                <b-form-input :disabled="disabled" v-model="object.last_name" />
                <b-form-text
                  text-variant="danger"
                  :key="key"
                  v-for="(error, key) in errors"
                  >{{ error }}</b-form-text
                >
              </b-form-group>
            </validation-provider>

            <div class="row align-items-center justify-content-center">
              <div class="col-5">
                <div class="mb-2">Available Permissions</div>
                <div class="block">
                  <div
                    v-for="(permission, i) in permissions.filter(
                      (each) => each.available
                    )"
                    :key="i"
                    class="entity"
                    :style="getEntityStyle(permission)"
                    @click="selectEntity(permission, 'permissions')"
                  >
                    {{ permission.label }}
                  </div>
                </div>
              </div>
              <div class="col-2">
                <button
                  class="btn btn-icon btn-circle btn-hover-dark"
                  :disabled="!permissions.find((each) => each.available)"
                  @click.stop="moveAllAvailableToSelected('permissions')"
                >
                  <i class="material-icons icon-xl"
                    >keyboard_double_arrow_right</i
                  >
                </button>
                <button
                  class="btn btn-icon btn-circle btn-hover-dark"
                  :disabled="
                    !permissions.find((each) => each.selected && each.available)
                  "
                  @click.stop="moveAvailableToSelected('permissions')"
                >
                  <i class="material-icons icon-xl">keyboard_arrow_right</i>
                </button>
                <button
                  class="btn btn-icon btn-circle btn-hover-dark"
                  :disabled="
                    !permissions.find(
                      (each) => each.selected && !each.available
                    )
                  "
                  @click.stop="moveSelectedToAvailble('permissions')"
                >
                  <i class="material-icons icon-xl">keyboard_arrow_left</i>
                </button>
                <button
                  class="btn btn-icon btn-circle btn-hover-dark"
                  :disabled="!permissions.find((each) => !each.available)"
                  @click.stop="moveAllSelectedToAvailble('permissions')"
                >
                  <i class="material-icons icon-xl"
                    >keyboard_double_arrow_left</i
                  >
                </button>
              </div>
              <div class="col-5">
                <div class="mb-2">Selected Permissions</div>
                <div class="block">
                  <div
                    v-for="(permission, i) in permissions.filter(
                      (each) => !each.available
                    )"
                    :key="i"
                    class="entity"
                    :style="getEntityStyle(permission)"
                    @click="selectEntity(permission, 'permissions')"
                  >
                    {{ permission.label }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row align-items-center justify-content-center mt-8">
              <div class="col-5">
                <div class="mb-2">Available Groups</div>
                <div class="block">
                  <div
                    v-for="(group, i) in groups.filter(
                      (each) => each.available
                    )"
                    :key="i"
                    class="entity"
                    :style="getEntityStyle(group)"
                    @click="selectEntity(group, 'groups')"
                  >
                    {{ group.label }}
                  </div>
                </div>
              </div>
              <div class="col-2">
                <button
                  class="btn btn-icon btn-circle btn-hover-dark"
                  :disabled="!groups.find((each) => each.available)"
                  @click.stop="moveAllAvailableToSelected('groups')"
                >
                  <i class="material-icons icon-xl"
                    >keyboard_double_arrow_right</i
                  >
                </button>
                <button
                  class="btn btn-icon btn-circle btn-hover-dark"
                  :disabled="
                    !groups.find((each) => each.selected && each.available)
                  "
                  @click.stop="moveAvailableToSelected('groups')"
                >
                  <i class="material-icons icon-xl">keyboard_arrow_right</i>
                </button>
                <button
                  class="btn btn-icon btn-circle btn-hover-dark"
                  :disabled="
                    !groups.find((each) => each.selected && !each.available)
                  "
                  @click.stop="moveSelectedToAvailble('groups')"
                >
                  <i class="material-icons icon-xl">keyboard_arrow_left</i>
                </button>
                <button
                  class="btn btn-icon btn-circle btn-hover-dark"
                  :disabled="!groups.find((each) => !each.available)"
                  @click.stop="moveAllSelectedToAvailble('groups')"
                >
                  <i class="material-icons icon-xl"
                    >keyboard_double_arrow_left</i
                  >
                </button>
              </div>
              <div class="col-5">
                <div class="mb-2">Selected Groups</div>
                <div class="block">
                  <div
                    v-for="(group, i) in groups.filter(
                      (each) => !each.available
                    )"
                    :key="i"
                    class="entity"
                    :style="getEntityStyle(group)"
                    @click="selectEntity(group, 'groups')"
                  >
                    {{ group.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </template>

    <template #modal-footer>
      <div class="d-flex justify-content-between mx-auto">
        <b-button
          class="btn-pill font-weight-bold"
          variant="dark"
          :disabled="disabled"
          :class="{
            'spinner spinner-success spinner-lg spinner-left': sending,
          }"
          @click.stop="submit"
        >
          <span v-if="sending">Submitting...</span>
          <span v-else>Submit</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

import UsersService from "@/services/users.service";
import PermissionsService from "@/services/permissions.service";
import GroupsService from "@/services/groups.service";
import CountriesDropdown from "@/components/countries.dropdown";
import CurrenciesDropdown from "@/components/currencies.dropdown";
import { formatErrorMessage } from "@/utils/random_utils";

export default {
  name: "UserForm",
  components: {
    ValidationObserver,
    ValidationProvider,
    CountriesDropdown,
    CurrenciesDropdown,
  },
  data() {
    return {
      id: null,
      error: null,
      fetching: false,
      sending: false,
      permissions: [],
      groups: [],
      selectedPermissions: [],
      object: {
        email: null,
        first_name: null,
        last_name: null,
      },
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    selectEntity(record, field) {
      this[field] = this[field].map((each) => {
        if (each.name === record.name) {
          each.selected = !each.selected;
        }
        return each;
      });
    },
    getEntityStyle(record) {
      if (record.selected) {
        return `background-color:#e4e6ef;`;
      } else {
        return `background-color:white;`;
      }
    },
    moveAllAvailableToSelected(field) {
      this[field] = this[field].map((each) => {
        if (each.available) {
          each.available = false;
        }
        return each;
      });
    },
    moveAvailableToSelected(field) {
      this[field] = this[field].map((each) => {
        if (each.selected && each.available) {
          each.available = false;
          each.selected = false;
        }
        return each;
      });
    },
    moveAllSelectedToAvailble(field) {
      this[field] = this[field].map((each) => {
        if (!each.available) {
          each.available = true;
        }
        return each;
      });
    },
    moveSelectedToAvailble(field) {
      this[field] = this[field].map((each) => {
        if (each.selected && !each.available) {
          each.available = true;
          each.selected = false;
        }
        return each;
      });
    },
    async fetch() {
      this.error = null;
      this.fetching = true;

      UsersService.get(this.id)
        .then(({ data }) => {
          this.set(data);
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    async create(payload) {
      UsersService.post(payload)
        .then(({ data }) => {
          this.$refs["modal"].hide();
          this.$parent.query();
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    async update(payload) {
      UsersService.patch(this.id, payload)
        .then(({ data }) => {
          this.$refs["modal"].hide();
          this.$parent.query();
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    async submit() {
      const valid = await this.$refs.observer.validate();

      if (!valid) return;

      this.error = null;
      this.sending = true;

      const payload = {
        email: this.object?.email,
        first_name: this.object?.first_name,
        last_name: this.object?.last_name,
        permissions: this.permissions
          .filter((each) => !each.available)
          .map((each) => each.name),
        groups: this.groups
          .filter((each) => !each.available)
          .map((each) => {
            return { id: each.id, name: each.name };
          }),
      };

      if (this.id) return this.update(payload);

      return this.create(payload);
    },
    set(data) {
      if (data.email) {
        this.object["email"] = data.email;
      }
      if (data.first_name) {
        this.object["first_name"] = data.first_name;
      }
      if (data.last_name) {
        this.object["last_name"] = data.last_name;
      }
      if (data.permissions.length) {
        this.permissions = this.permissions.map((each) => {
          if (data.permissions.indexOf(each.name) >= 0) {
            each.available = false;
          }
          return each;
        });
      }
      if (data.groups.length) {
        this.groups = this.groups.map((each) => {
          if (data.groups.find((rec) => rec.id === each.id)) {
            each.available = false;
          }
          return each;
        });
      }
    },
    reset() {
      if (this.$refs.observer) this.$refs.observer.reset();

      this.object = {
        email: null,
        first_name: null,
        last_name: null,
      };
    },
    show(id) {
      this.$refs["modal"].show();

      this.id = id || null;

      if (this.id) this.fetch();
    },
    flush() {
      this.fetching = false;
      this.sending = false;
      this.error = null;
      this.permissions = this.permissions.map((each) => {
        each.selected = false;
        each.available = true;
        return each;
      });
      this.groups = this.groups.map((each) => {
        each.selected = false;
        each.available = true;
        return each;
      });
      this.reset();
    },
  },
  computed: {
    disabled() {
      return this.sending || this.fetching;
    },
    variants() {
      return {
        show: this.error,
        "alert-light-danger": this.error,
      };
    },
  },
  mounted() {
    this.querying = true;
    PermissionsService.query()
      .then(({ data }) => {
        this.permissions = data.map((each) => {
          return {
            name: each,
            label:
              this.capitalizeFirstLetter(each.split(":")[1]) +
              " " +
              this.capitalizeFirstLetter(each.split(":")[0]),
            selected: false,
            available: true,
          };
        });
      })
      .catch(({ message }) => {
        this.error = "There was an error loading permissions.";
      })
      .finally(() => {
        this.querying = false;
      });

    this.querying = true;
    GroupsService.query()
      .then(({ data }) => {
        this.groups = data.map((each) => {
          return {
            id: each.id,
            name: each.name,
            label: each.name,
            selected: false,
            available: true,
          };
        });
      })
      .catch(({ message }) => {
        this.error = "There was an error loading groups.";
      })
      .finally(() => {
        this.querying = false;
      });
  },
};
</script>

<style scoped>
.block {
  height: 120px;
  overflow: auto;
  border: 1px solid #e4e6ef;
  background-color: #ffffff;
  border-radius: 10px;
}
.entity {
  margin: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 8px;
}
</style>
